import { SiteAssignment, SiteAssignmentEntity } from "../../../model/site-assignment";
import { getUseQueryResultData } from "../../../util/selector-util";
import { createSelector } from "@reduxjs/toolkit";

export type SiteAssignmentSelectorProps = {
  // selector props here
};

export const siteAssignmentSelector = () => createSelector(
  [getUseQueryResultData<SiteAssignment>],
  (data) => {
    return data ? selectSiteAssignmentAndTransform(data, {}) : undefined;
  }
);

export const selectSiteAssignments = (values?: SiteAssignment[], selector?: SiteAssignmentSelectorProps): SiteAssignment[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    return true;
  });
};

export const selectSiteAssignmentsAndTransform = (values?: SiteAssignment[], selector?: SiteAssignmentSelectorProps): SiteAssignmentEntity[] => {
  const selected = selectSiteAssignments(values, selector);
  return selected.map(m => SiteAssignmentEntity.from(m));
};

export const selectSiteAssignmentAndTransform = (value: SiteAssignment, selector?: SiteAssignmentSelectorProps): SiteAssignmentEntity => {
  const transformed = selectSiteAssignmentsAndTransform([value], selector);
  return transformed[0];
};
